import claims from "../features/Claims/ClaimsSlice";
const rootReducer = { claims };
export default rootReducer;
